<div class="branding-panel">
  <!-- Header Section with Close Button -->
  <div class="branding-header">
    <h1 class="branding-title">Branding</h1>
    <button class="close-btn" (click)="onClose()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Logo Upload Section -->
  <div class="branding-section">
    <div class="section-header">
      <h2 class="section-title">Logo Upload</h2>
    </div>

    <div class="logo-upload-wrapper">
      <!-- Logo Preview -->
      <div class="logo-preview-area" (dragover)="onDragOver($event)" (drop)="onDrop($event)" (click)="!logoPreview && !brandingData.logoUrl ? fileInput.click() : null">
        <div class="logo-preview" [class.has-logo]="logoPreview || brandingData.logoUrl">
          <!-- Loading State -->
          <div *ngIf="isUploadingLogo" class="logo-loading">
            <div class="loading-spinner"></div>
          </div>

          <!-- Placeholder when no logo -->
          <div *ngIf="!logoPreview && !brandingData.logoUrl && !isUploadingLogo" class="logo-placeholder">
            <span class="logo-placeholder-text">No logo uploaded</span>
          </div>

          <!-- Logo Preview Image -->
          <img *ngIf="(logoPreview || brandingData.logoUrl) && !isUploadingLogo"
            [src]="logoPreview || brandingData.logoUrl" alt="Brand Logo" class="logo-image">
        </div>
      </div>

      <!-- Replace Button -->
      <button class="replace-btn" (click)="fileInput.click()" [disabled]="isUploadingLogo">
        Replace
      </button>
      <input #fileInput type="file" accept="image/png,image/jpeg,image/jpg,image/gif,image/svg+xml"
        (change)="onFileSelected($event)" [disabled]="isUploadingLogo" style="display: none;">

      <!-- Upload Guidelines -->
      <div class="upload-guidelines">
        <span>Recommended: 250×100 px .png, .svg | Max size: 000 KB</span>
      </div>

      <!-- Upload Error Message -->
      <div *ngIf="uploadError" class="upload-error">
        {{ uploadError }}
      </div>
    </div>
  </div>

  <!-- Brand & Font Colors Section -->
  <div class="branding-section">
    <div class="section-header">
      <h2 class="section-title">Brand & Font Colors</h2>
    </div>

    <div class="colors-container">
      <div class="color-item square" [style.background-color]="brandingData.colors.primary" (click)="openColorPicker('primary')">
        <div class="color-info">
          <div class="color-label" [style.color]="getContrastingTextColor(brandingData.colors.primary)">Primary</div>
          <div class="color-value" [style.color]="getContrastingTextColor(brandingData.colors.primary)">{{ brandingData.colors.primary.toUpperCase() }}</div>
        </div>
      </div>

      <div class="color-item square" [style.background-color]="brandingData.colors.heading" (click)="openColorPicker('heading')">
        <div class="color-info">
          <div class="color-label" [style.color]="getContrastingTextColor(brandingData.colors.heading)">Heading</div>
          <div class="color-value" [style.color]="getContrastingTextColor(brandingData.colors.heading)">{{ brandingData.colors.heading.toUpperCase() }}</div>
        </div>
      </div>

      <div class="color-item square" [style.background-color]="brandingData.colors.paragraph" (click)="openColorPicker('paragraph')">
        <div class="color-info">
          <div class="color-label" [style.color]="getContrastingTextColor(brandingData.colors.paragraph)">Paragraph</div>
          <div class="color-value" [style.color]="getContrastingTextColor(brandingData.colors.paragraph)">{{ brandingData.colors.paragraph.toUpperCase() }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Font Selection Section -->
  <div class="branding-section">
    <div class="section-header">
      <h2 class="section-title">Font Selection</h2>
    </div>

    <div class="fonts-container">
      <div class="font-item" (click)="openFontModal('heading')">
        <div class="font-label">Heading</div>
        <div class="font-preview" [style.font-family]="getFontFamilyString(brandingData.fonts.heading)">
          {{ brandingData.fonts.heading || 'Select font' }}
        </div>
      </div>

      <div class="font-item" (click)="openFontModal('body')">
        <div class="font-label">Body</div>
        <div class="font-preview" [style.font-family]="getFontFamilyString(brandingData.fonts.body)">
          {{ brandingData.fonts.body || 'Select font' }}
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Color Picker Modal -->
<div class="color-picker-overlay" *ngIf="isColorPickerOpen" (click)="closeColorPicker()">
  <div class="color-picker-modal" (click)="$event.stopPropagation()">
    <div class="color-picker-header">
      <h3 class="color-picker-title">Color picker</h3>
      <button class="color-picker-close" (click)="closeColorPicker()">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="color-picker-content">
      <chrome-picker 
        [(color)]="currentPickerColor" 
        (colorChange)="onColorPickerChange()">
      </chrome-picker>
    </div>

  </div>
</div>

<!-- Font Selection Modal -->
<app-font-selection-modal
  [isOpen]="isFontModalOpen"
  [title]="currentFontType === 'heading' ? 'Heading' : 'Body'"
  [selectedFont]="getCurrentSelectedFont()"
  [fonts]="getCurrentFontList()"
  (close)="closeFontModal()"
  (fontSelected)="onFontSelected($event)">
</app-font-selection-modal>